import config from 'config';
import Footer from 'NOTICEBOARD/Footer/Footer';
import Header from 'NOTICEBOARD/Header/Header';
import RoutesSetup from 'NOTICEBOARD/Routes/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

function App() {
  	return (
		<div className="App">
			<Header />
			<div id="routeSetup">
				<RoutesSetup />
			</div>
			<Footer />
			<ToastContainer theme="light" style={{marginTop:'45px'}} />
		</div>
  	);
}

export default App;
